import { useState, useEffect} from 'react'
import { Container, Row, Col} from 'react-bootstrap'
import { ArrowRightCircle } from 'react-bootstrap-icons'
import headerImg from '../assets/img/banner_img1.gif'
export const Banner=()=>{
    const[loopNum, setLoopNum] = useState(0)
    const[isDeleting, setIsDeleting] = useState(0)
    const toRotate=['Web Developer', 'Computer Engineer','Software Developer']
    const[delta,setDelta]=useState(300-Math.random()*100)
    const[index, setIndex]=useState(1)
    const[text,setText]=useState('')
    const period=2000

    useEffect(()=>{
        let ticker=setInterval(()=>{
            tick()
        },delta)
        return()=>{clearInterval(ticker)}
    },[text])

    const tick=()=>{
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);
    
        setText(updatedText);
    
        if (isDeleting) {
          setDelta(prevDelta => prevDelta / 2);
        }
    
        if (!isDeleting && updatedText === fullText) {
          setIsDeleting(true);
          setIndex(prevIndex => prevIndex - 1);
          setDelta(period);
        } else if (isDeleting && updatedText === '') {
          setIsDeleting(false);
          setLoopNum(loopNum + 1);
          setIndex(1);
          setDelta(500);
        } else {
          setIndex(prevIndex => prevIndex + 1);
        }
    }
    return(
        <section className='banner' id='home'>
        <Container>
            <Row className='align-items-center'>
                <Col xs={12} md={6} xl={7}>
                     <h1>{`Hi I'm Suzan-  `}<span className='wrap'>{text}</span></h1>
                    <p>I love building software projects that can impact the society!</p>
                    <span className='tagline'>Welcome to my Portfolio!</span>
                   
                    <button onClick={()=>window.open('https://github.com/suzandsouza')}>Let's connect <ArrowRightCircle size={25}></ArrowRightCircle></button>

                    
                </Col>
                <Col xs={12}md={6} xl={5}>
                    <img src={headerImg} alt="Header"></img>
                </Col>
                
            </Row>
        </Container>
        </section>
    )
}